const NoPage = () => {
    return <div class="container">
        <div class="card">
            <div class="card-body">
                <div class="container">
                    <h4>404</h4>
                </div>
            </div>
        </div>
    </div>
};

export default NoPage;
